import { render, staticRenderFns } from "./addedMessage.vue?vue&type=template&id=339efc44"
import script from "./addedMessage.vue?vue&type=script&lang=js"
export * from "./addedMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports